import { motion } from "framer-motion";
import {
    Lock,
    ShoppingBag,
    Sparkles,
    CheckCircle,
    ArrowRight
} from "lucide-react";

export default function LockedCommunity({

    community,

    featuredProducts = [],

    onShopNow,

    onProductClick

}) {

    return (

        <div className="max-w-6xl mx-auto py-12">

            <motion.div

                initial={{ opacity: 0, y: 30 }}

                animate={{ opacity: 1, y: 0 }}

                className="
                    rounded-[36px]
                    overflow-hidden
                    bg-white/70
                    backdrop-blur-2xl
                    border
                    border-white/30
                    shadow-2xl
                "

            >

                {/* Hero */}

                <div
                    className={`
                        relative
                        p-14
                        bg-gradient-to-r
                        ${community.gradient}
                    `}
                >

                    <div className="absolute inset-0 bg-black/20"/>

                    <div className="relative z-10 text-center">

                        <div
                            className="
                                w-24
                                h-24
                                rounded-full
                                bg-white/20
                                backdrop-blur-xl
                                flex
                                items-center
                                justify-center
                                mx-auto
                            "
                        >

                            <Lock
                                size={46}
                                className="text-white"
                            />

                        </div>

                        <h1
                            className="
                                mt-8
                                text-5xl
                                font-black
                                text-white
                            "
                        >

                            {community.title} Locked

                        </h1>

                        <p
                            className="
                                mt-5
                                text-xl
                                text-white/90
                                max-w-2xl
                                mx-auto
                            "
                        >

                            Purchase any product from the{" "}

                            <strong>

                                {community.shortTitle}

                            </strong>

                            {" "}collection in 5Buddies to unlock
                            exclusive discussions, creators,
                            events and knowledge.

                        </p>

                    </div>

                </div>

                {/* Benefits */}

                <div className="p-10">

                    <h2
                        className="
                            text-2xl
                            font-bold
                            mb-8
                        "
                    >

                        What you'll unlock

                    </h2>

                    <div
                        className="
                            grid
                            md:grid-cols-2
                            gap-6
                        "
                    >

                        <Benefit>

                            Unlimited Community Posts

                        </Benefit>

                        <Benefit>

                            Create Discussions

                        </Benefit>

                        <Benefit>

                            Like & Comment

                        </Benefit>

                        <Benefit>

                            Exclusive Community Events

                        </Benefit>

                        <Benefit>

                            Creator Meetups

                        </Benefit>

                        <Benefit>

                            Premium Product Drops

                        </Benefit>

                    </div>

                    {/* Products */}

                    {

                        featuredProducts.length>0 && (

                            <>

                                <h2
                                    className="
                                        text-2xl
                                        font-bold
                                        mt-14
                                        mb-8
                                    "
                                >

                                    Unlock with these products

                                </h2>

                                <div
                                    className="
                                        grid
                                        md:grid-cols-3
                                        gap-6
                                    "
                                >

                                    {

                                        featuredProducts.map(product=>(

                                            <button

                                                key={product.id}

                                                onClick={()=>

                                                    onProductClick(product)

                                                }

                                                className="
                                                    rounded-3xl
                                                    overflow-hidden
                                                    bg-gray-50
                                                    hover:shadow-xl
                                                    transition
                                                    text-left
                                                "

                                            >

                                                <img

                                                    src={product.image}

                                                    alt=""

                                                    className="
                                                        h-64
                                                        w-full
                                                        object-cover
                                                    "

                                                />

                                                <div className="p-5">

                                                    <div
                                                        className="
                                                            font-semibold
                                                            text-lg
                                                        "
                                                    >

                                                        {product.name}

                                                    </div>

                                                    <div
                                                        className="
                                                            mt-2
                                                            text-blue-600
                                                            font-bold
                                                            text-xl
                                                        "
                                                    >

                                                        ₹{product.price}

                                                    </div>

                                                </div>

                                            </button>

                                        ))

                                    }

                                </div>

                            </>

                        )

                    }

                    {/* CTA */}

                    <div className="mt-14 text-center">

                        <button

                            onClick={onShopNow}

                            className={`
                                inline-flex
                                items-center
                                gap-3
                                px-10
                                py-5
                                rounded-full
                                text-white
                                font-semibold
                                text-lg
                                shadow-xl
                                ${community.button}
                            `}

                        >

                            <ShoppingBag size={22}/>

                            Shop Collection

                            <ArrowRight size={18}/>

                        </button>

                    </div>

                </div>

            </motion.div>

        </div>

    );

}

function Benefit({

    children

}){

    return(

        <div
            className="
                flex
                gap-4
                items-center
                rounded-2xl
                bg-gray-50
                p-5
            "
        >

            <CheckCircle

                className="text-green-500"

                size={22}

            />

            <span className="font-medium">

                {children}

            </span>

        </div>

    );

}